module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "player3ModThree"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4569.62851,385.766618 C4569.40811,388.084229 4567.84959,388.614429 4565.98277,391.208893 C4563.80466,394.235991 4563.52764,399.976507 4561,404.630572 C4561.51097,405.794929 4565.32176,404.015394 4566.22995,402.136081 C4567.13815,400.256768 4567.836,398.726141 4568.13521,398.256767 C4568.43443,397.787392 4569.06955,397.876878 4569.22408,398.358229 C4569.37861,398.83958 4568.39957,415.765792 4568.72796,416.628103 C4569.05634,417.490415 4571.27194,417.713518 4571.72933,416.890191 C4572.18672,416.066865 4573.30567,402.704755 4573.52423,402.363591 C4573.7428,402.022427 4574.2153,402.237077 4574.40488,402.440491 C4574.59446,402.643905 4572.98868,416.881921 4573.27333,417.441836 C4573.55799,418.001751 4575.85687,418.109775 4576.14314,417.692435 C4576.42941,417.275095 4577.76122,403.058949 4578.03862,402.757799 C4578.31602,402.456649 4578.81756,402.536882 4578.99892,402.841655 C4579.18028,403.146429 4577.41621,416.793883 4577.72163,417.413455 C4578.02704,418.033027 4580.24735,418.236267 4580.50411,417.656428 C4580.76086,417.076589 4582.42169,403.342144 4582.65437,403.160859 C4582.88705,402.979573 4583.17482,403.023558 4583.36394,403.222821 C4583.55307,403.422083 4582.86824,413.728716 4583.17361,414.318795 C4583.47898,414.908874 4585.14837,415.187777 4585.45675,414.518165 C4585.76513,413.848554 4586.77853,388.666607 4586.93351,387.277737 C4587.45001,382.649237 4584.96722,377.550836 4579.13397,377.041461 C4573.30071,376.532085 4570.10179,380.789741 4569.62851,385.766618 Z",
      "id": "player3_right_hand",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4582.22644,342.033586 C4586.91136,342.451807 4590.37696,346.666028 4589.96708,351.446313 L4586.99849,386.068198 C4586.58862,390.848483 4582.45847,394.384635 4577.77356,393.966414 C4573.08864,393.548193 4569.62304,389.333972 4570.03292,384.553687 L4573.00151,349.931802 C4573.41138,345.151517 4577.54153,341.615365 4582.22644,342.033586 Z",
      "id": "player3_right_arm_bottom",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4587.9559,281.0336 C4592.80386,281.452001 4596.39008,285.668038 4595.96594,290.450382 L4590.5901,351.064782 C4590.16596,355.847126 4585.89207,359.384801 4581.0441,358.9664 C4576.19614,358.547999 4572.60992,354.331962 4573.03406,349.549618 L4578.4099,288.935218 C4578.83404,284.152874 4583.10793,280.615199 4587.9559,281.0336 Z",
      "id": "player3_right_arm_top",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4586.91601,281.043247 C4592.86554,281.571076 4597.32403,286.798471 4596.98152,292.844662 L4594.53686,336 L4570,333.823146 L4574.98251,290.89296 C4575.68057,284.878314 4580.96648,280.515418 4586.91601,281.043247 Z",
      "id": "player3_right_sleeve_2",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player3_right_sleeve_1",
      "fill": "#80A259",
      "points": "4595 332.304209 4594.61802 337 4570 334.68351 4570.5125 330"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player3_right_sock",
      "fill": "#6D8C4A",
      "x": "4581",
      "y": "486",
      "width": "20",
      "height": "29"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4558.88007,522.605306 C4562.7367,521.699219 4571.91639,515.847961 4579.25615,510.711122 C4584.12223,512.151052 4596.44766,512.2726 4601.24545,510.711122 C4603.47446,509.985674 4605.42393,509.17372 4605.95166,511.832233 C4606.30349,513.604574 4604.73475,514.727109 4601.24545,515.199837 L4601.24545,536 L4547.08394,536 C4546.36223,529.08737 4550.29427,524.622472 4558.88007,522.605306 Z",
      "id": "player3_right_shoe_5",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4557.73995,522.572676 C4561.5872,521.639953 4577.27418,511.49235 4578.09021,510.401563 C4578.90624,509.310777 4579.13765,505.143534 4579.8634,497.452793 C4581.27233,495.693229 4588.45733,495.16234 4589.6384,497.980503 C4590.81947,500.798667 4588.97691,506.201474 4586.0049,511.470097 C4583.0329,516.73872 4570.47276,523.587962 4565.57974,525.370574 C4560.68672,527.153185 4554.92958,524.809087 4557.73995,522.572676 Z",
      "id": "player3_right_shoe_4",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player3_right_shoe_3",
      "fill": "#6D8C4A",
      "points": "4574 513.464261 4577.4453 511 4583 517.165369 4579.50568 520"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player3_right_shoe_2",
      "fill": "#6D8C4A",
      "points": "4565 519.464261 4568.4453 517 4574 523.165369 4570.50568 526"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "player3_right_shoe_1",
      "fill": "#80A259",
      "cx": "4592",
      "cy": "525.5",
      "rx": "5",
      "ry": "5.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4591,437 L4591,437 L4591,437 C4596.52285,437 4601,441.477153 4601,447 L4601,486 L4581,486 L4581,447 L4581,447 C4581,441.477153 4585.47715,437 4591,437 Z",
      "id": "player3_right_leg_bottom",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4591.69231,368 L4591.69231,368 L4591.69231,368 C4599.59423,368 4606,374.405772 4606,382.307692 L4606,457 L4575,457 L4577.0014,382.302559 L4577.0014,382.302559 C4577.21468,374.342254 4583.72915,368 4591.69231,368 Z",
      "id": "player3_right_leg_top",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player3_left_sock",
      "fill": "#6D8C4A",
      "x": "4614",
      "y": "486",
      "width": "20",
      "height": "29"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4591.88007,522.605306 C4595.7367,521.699219 4604.91639,515.847961 4612.25615,510.711122 C4617.12223,512.151052 4629.44766,512.2726 4634.24545,510.711122 C4636.47446,509.985674 4638.42393,509.17372 4638.95166,511.832233 C4639.30349,513.604574 4637.73475,514.727109 4634.24545,515.199837 L4634.24545,536 L4580.08394,536 C4579.36223,529.08737 4583.29427,524.622472 4591.88007,522.605306 Z",
      "id": "player3_left_shoe_5",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4590.73995,522.572676 C4594.5872,521.639953 4610.27418,511.49235 4611.09021,510.401563 C4611.90624,509.310777 4612.13765,505.143534 4612.8634,497.452793 C4614.27233,495.693229 4621.45733,495.16234 4622.6384,497.980503 C4623.81947,500.798667 4621.97691,506.201474 4619.0049,511.470097 C4616.0329,516.73872 4603.47276,523.587962 4598.57974,525.370574 C4593.68672,527.153185 4587.92958,524.809087 4590.73995,522.572676 Z",
      "id": "player3_left_shoe_4",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player3_left_shoe_3",
      "fill": "#6D8C4A",
      "points": "4607 513.464261 4610.4453 511 4616 517.165369 4612.50568 520"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player3_left_shoe_2",
      "fill": "#6D8C4A",
      "points": "4598 519.464261 4601.4453 517 4607 523.165369 4603.50568 526"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "player3_left_shoe_1",
      "fill": "#80A259",
      "cx": "4624",
      "cy": "525.5",
      "rx": "5",
      "ry": "5.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4624,437 L4624,437 L4624,437 C4629.52285,437 4634,441.477153 4634,447 L4634,486 L4614,486 L4614,447 L4614,447 C4614,441.477153 4618.47715,437 4624,437 Z",
      "id": "player3_left_leg_bottom",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4622.30769,368 L4622.30769,368 L4622.30769,368 C4630.27085,368 4636.78532,374.342254 4636.9986,382.302559 L4639,457 L4608,457 L4608,382.307692 L4608,382.307692 C4608,374.405772 4614.40577,368 4622.30769,368 Z",
      "id": "player3_left_leg_top",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4578,368 L4638,368 L4638,392 L4638,392 C4638,399.179702 4632.1797,405 4625,405 L4591,405 L4591,405 C4583.8203,405 4578,399.179702 4578,392 L4578,368 Z",
      "id": "player3_hip",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4608.10174,275 C4613.27199,275 4628.84865,277.517761 4633.09989,280.860089 C4634.23071,292.670357 4639.96228,386.281901 4638.85994,392.710847 C4631.73681,394.84778 4584.18423,393.954569 4576,392.710847 C4576.93707,386.093068 4582.05145,300.230722 4583.8572,280.860089 C4591.81324,276.727027 4602.93148,275 4608.10174,275 Z",
      "id": "player3_shirt_3",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4609,309 L4624,309 L4624,324 L4624,324 C4624,325.656854 4622.65685,327 4621,327 L4612,327 L4612,327 C4610.34315,327 4609,325.656854 4609,324 L4609,309 Z",
      "id": "player3_shirt_2",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4607.84837,275 C4610.51711,275 4615.83988,275.562052 4620.9816,276.290961 C4625.89591,276.987632 4622.21466,293.740272 4605.75042,293.997283 C4589.28619,294.254294 4590.43928,276.192842 4594.77253,275.690946 C4599.84159,275.103825 4605.03441,275 4607.84837,275 Z",
      "id": "player3_shirt_1",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4625.87656,386.490505 C4625.85956,388.81154 4624.36885,389.473323 4622.75259,392.212132 C4620.86681,395.407646 4621.08978,401.133322 4619,405.975103 C4619.60438,407.087259 4623.20761,404.989257 4623.94059,403.043899 C4624.67356,401.098541 4625.22929,399.517752 4625.48372,399.025604 C4625.73815,398.533456 4626.37204,398.567251 4626.56599,399.031941 C4626.75993,399.49663 4627.25745,416.393155 4627.65572,417.221147 C4628.05398,418.049139 4630.2576,418.078569 4630.63739,417.221147 C4631.01717,416.363725 4630.9656,402.995036 4631.1516,402.637225 C4631.3376,402.279415 4631.82198,402.451631 4632.02646,402.637225 C4632.23095,402.82282 4631.87825,417.103707 4632.20728,417.635143 C4632.5363,418.166578 4634.81208,418.074485 4635.05824,417.635143 C4635.30441,417.1958 4635.38889,402.960396 4635.63635,402.637225 C4635.88381,402.314055 4636.38521,402.350245 4636.59035,402.637225 C4636.79548,402.924206 4636.2357,416.632259 4636.59035,417.221147 C4636.945,417.810035 4639.15153,417.819329 4639.35456,417.221147 C4639.55759,416.622965 4640.00807,402.837464 4640.2218,402.637225 C4640.43553,402.436987 4640.72304,402.455715 4640.92672,402.637225 C4641.1304,402.818736 4641.34591,413.114983 4641.69796,413.674582 C4642.05002,414.23418 4643.71996,414.366406 4643.96612,413.674582 C4644.21228,412.982758 4643.0352,387.883413 4643.06798,386.490505 C4643.1772,381.848545 4640.28885,377 4634.49389,377 C4628.69892,377 4625.91308,381.506275 4625.87656,386.490505 Z",
      "id": "player3_left_hand",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player3_left_arm_bottom",
      "fill": "#AFD485",
      "x": "4626",
      "y": "342",
      "width": "17",
      "height": "52",
      "rx": "8.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player3_left_arm_top",
      "fill": "#AFD485",
      "x": "4626",
      "y": "281",
      "width": "17",
      "height": "78",
      "rx": "8.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4634.5,281 L4634.5,281 L4634.5,281 C4640.56195,281 4645.52632,285.817845 4645.70788,291.877076 L4647,335 L4622,335 L4623.29212,291.877076 L4623.29212,291.877076 C4623.47368,285.817845 4628.43805,281 4634.5,281 Z",
      "id": "player3_left_sleeve_2",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player3_left_sleeve_1",
      "fill": "#80A259",
      "points": "4647 330 4647 334 4622 334 4622.13255 330"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4600.49108,268.553784 C4601.15837,272.849064 4600.49108,278.219161 4596.65086,278.219161 C4596.20504,280.521512 4593.35865,290.737306 4604.49778,290.994076 C4615.63691,291.250847 4617.95893,283.099982 4618,278.219161 C4613.67294,278.219161 4612.64755,273.353029 4613.67294,268.553784 C4612.39873,265.091015 4602.27034,265.206956 4600.49108,268.553784 Z",
      "id": "player3_neck",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4636.99543,237.963228 C4638.69734,236.957869 4641.14059,235.680702 4643.91073,237.963228 C4646.28019,239.915602 4644.49908,247.574975 4641.30277,251.816712 C4638.13676,256.018248 4632.98664,256.890568 4630.96515,255.280084 C4626.7003,264.935837 4615.83099,270.06325 4608.56698,269.999411 C4589.1197,269.828501 4581,250.057079 4581,233.634014 C4581,207.729591 4591.30804,199.000645 4608.56698,199.000645 C4624.05793,198.91599 4641.2523,207.138717 4636.99543,237.963228 Z",
      "id": "player3_face",
      "fill": "#AFD485",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "player3_mouth_bottom"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4598.32575,263 C4599.47905,263 4609.49181,263 4610.78027,263 C4612.06873,263 4607.44625,261 4603.29344,261 C4599.14062,261 4597.17245,263 4598.32575,263 Z",
      "fill": "#94B96B",
      "transform": "translate(4604.500000, 262.000000) scale(1, -1) translate(-4604.500000, -262.000000) "
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4596.40093,261 C4597.82037,261 4610.14376,261 4611.72956,261 C4613.31536,261 4607.62615,258 4602.515,258 C4597.40384,258 4594.98148,261 4596.40093,261 Z",
      "id": "player3_mouth_top",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4635.79252,245.32904 C4637.39642,242.130526 4639.90402,239.165694 4642.9626,240.21508 C4646.02117,241.264465 4642.10485,253.017771 4634,252.99998 C4634.93805,252.449484 4637.50211,249.887903 4637.58504,247.88602 C4637.66797,245.884137 4636.98757,244.881235 4635.79252,245.32904 Z",
      "id": "player3_ear",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4601.11476,237.278291 C4601.11476,235.646167 4605.38629,235.503139 4605.38839,237.278291 C4605.39049,239.053443 4606.76206,248.316183 4605.39049,249.962135 C4604.01891,251.608088 4599.987,251.056616 4599.36303,249.962135 C4598.73906,248.867654 4598.85672,247.082802 4600.21024,246.585611 C4601.56376,246.088419 4601.11476,238.910415 4601.11476,237.278291 Z",
      "id": "player3_nose",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4612.031,229.621746 C4612.51134,226.226369 4627.67552,226.17293 4627.97983,229.206047 C4628.28414,232.239164 4625.10825,230.792949 4620.92842,231.373277 C4616.7486,231.953606 4611.55066,233.017123 4612.031,229.621746 Z",
      "id": "player3_left_brow",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4598.969,229.621746 C4598.48866,226.226369 4583.32448,226.17293 4583.02017,229.206047 C4582.71586,232.239164 4585.89175,230.792949 4590.07158,231.373277 C4594.2514,231.953606 4599.44934,233.017123 4598.969,229.621746 Z",
      "id": "player3_right_brow",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4613,239.594484 C4615.28918,233.033766 4625.47003,232.032491 4627,237.713778 C4627.00726,245.385327 4614.66412,246.062908 4613,239.594484 Z",
      "id": "player3_left_eye_whites",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player3_left_pupil",
      "fill": "#6D8C4A",
      "cx": "4621.5",
      "cy": "239.5",
      "r": "3.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4599,239.594484 C4596.71082,233.033766 4586.52997,232.032491 4585,237.713778 C4584.99274,245.385327 4597.33588,246.062908 4599,239.594484 Z",
      "id": "player3_right_eye_whites",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player3_right_pupil",
      "fill": "#6D8C4A",
      "cx": "4593.5",
      "cy": "239.5",
      "r": "3.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4633.51137,247.256234 C4634.22156,240.961188 4638.21406,238.118226 4639.99639,237.437724 C4640.08933,225.419477 4638.37994,202.103539 4635.80468,200.227002 C4633.22941,198.350465 4587.29115,198.850531 4585.47039,200.227002 C4583.64962,201.603473 4581.69984,217.13527 4582.03866,219.232693 C4583.67825,218.251992 4629.60279,217.872481 4630.59219,219.232693 C4631.58159,220.592905 4630.59219,245.357489 4630.59219,246.801376 C4630.59219,248.245262 4633.03883,248.369387 4633.51137,247.256234 Z",
      "id": "player3_hair",
      "fill": "#6D8C4A"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-791ad7b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_3/svg/background/player3ModThree.vue
// module id = 746
// module chunks = 1